import React from 'react';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { WxLaunchHack } from '@ifeng-fe/three_terminal/es/mobile/wxLaunchHack/dynamic';
import { type callAppParmam, type statisticsParmam } from '@src/services/myInterface';

type AllData = {
    content: {
        text?: string;
        hasBorder?: boolean;
        callAppData: callAppParmam;
        statisticsData?: statisticsParmam;
    };
};

const ViewMore = ({ content }: AllData) => {
    const { text = '查看所有评论', hasBorder = true, callAppData, statisticsData } = content;
    const wxLaunchHackData = {
        callAppConfig: callAppData,
        statisticsConfig: statisticsData,
    };

    return (
        <div className={`${styles.viewMore} ${hasBorder ? styles.viewMoreBorder : ''}`}>
            <div className={styles.viewMoreText}>{text}</div>
            <WxLaunchHack content={wxLaunchHackData} />
        </div>
    );
};

export default errorBoundary(ViewMore);
